import React from 'react';
import UseFulFilesFunctional from './components/useful-files-functional';
import './useful-files-payroll.scss';

const UsefulFiles = () => {
	return <UseFulFilesFunctional />;
};
export default UsefulFiles;
